import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { projects } from '../data';
import { motion } from 'framer-motion';

const ProjectDetails = () => {
  const { slug } = useParams();
  const project = projects.find((p) => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!project) return (
    <div className="container details-view">
      <h2>Project not found</h2>
      <Link to="/" className="btn">Back Home</Link>
    </div>
  );

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      className="container details-view"
    >
      <Link to="/" className="back-link">← Back to Portfolio</Link>
      
      <header className="details-header">
        <p className="overline">{project.company} | {project.category}</p>
        <h1>{project.title}</h1>
        <a href={project.link} target="_blank" rel="noreferrer" className="btn">View Live Website</a>
      </header>

      <div className="details-grid">
        <div>
          <section className="details-section">
            <h3>My Role</h3>
            <p className="role-text">{project.role}</p>
          </section>

          <section className="details-section">
            <h3>Contribution & Responsibilities</h3>
            <p className="contribution-text">{project.whatIDid}</p>
          </section>
        </div>

        <aside className="details-sidebar">
          <h3>Technologies Used</h3>
          <ul>
            {project.technologies.map(tech => (
              <li key={tech}>
                <span>▹</span> {tech}
              </li>
            ))}
          </ul>
        </aside>
      </div>
    </motion.div>
  );
};

export default ProjectDetails;